import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/Index.vue'
import JobView from '../views/JobView.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/job/:id',
    name: 'jobView',
    component: JobView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_ROUTER_BASE),
  base: process.env.VUE_APP_ROUTER_BASE,
  routes
})

export default router
